import moment from 'moment';
import 'daterangepicker';
import 'daterangepicker/daterangepicker.css';
import { Controller } from 'stimulus';
import daterangePickerPtBr from '../entrypoints/src/admin/i18n/daterange-picker.pt-br';
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';

export default class extends Controller {
  static targets = ['picker', 'startInput', 'endInput', 'form'];

  connect() {
    moment.locale('pt-BR');
    this.dateRangePicker();
  }

  dateRangePicker() {
    if (!this.hasPickerTarget) return;

    const _this = this;
    const picker = $(this.pickerTarget);
    const startDate = moment(picker.data('startDate'), 'DD/MM/YYYY');
    const endDate = moment(picker.data('endDate'), 'DD/MM/YYYY');

    picker.daterangepicker({
      locale: daterangePickerPtBr,
      startDate,
      endDate,
      opens: 'left',
      applyButtonClasses: 'btn btn-sm btn-secondary',
      ranges: {
        'Hoje': [moment().startOf('day'), moment().endOf('day')],
        'Últimos 7 dias': [moment().subtract(6, 'day').startOf('day'), moment().endOf('day')],
        'Últimos 30 dias': [moment().subtract(29, 'day').startOf('day'), moment().endOf('day')],
        'Mês Passado': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Esse Mês': [moment().startOf('month'), moment().endOf('month')]
      }
    }, (start, end) => {
      AjaxLoader.show();
      _this.startInputTarget.value = start.format('DD/MM/YYYY');
      _this.endInputTarget.value = end.format('DD/MM/YYYY');
      _this.formTarget.submit();
    });

    this.renderPickerLabel(picker, startDate, endDate);
  }

  renderPickerLabel(picker, start, end) {
    const sameMonth =
      start.isSame(start.clone().startOf('month'), 'day') &&
      end.isSame(start.clone().endOf('month'), 'day');

    const range = sameMonth
      ? start.format('MMMM [de] YYYY')
      : `${start.format('DD MMM YYYY')} – ${end.format('DD MMM YYYY')}`;

    picker.html(`<i class="far fa-calendar"></i>&nbsp;${range}`);
  }
}
